import React from "react";
import "../../../stylesheet/components/about/ourjourney/OurJourney.scss";

type OurJourneyItemProps = {
  title: string;
  body: string;
};

const AboutCard: React.FC<OurJourneyItemProps> = ({ title, body }) => {
  return (
    <div className="journey-item card shadow-sm">
      <h5>{title}</h5>
      <p className="p2">{body}</p>
    </div>
  );
};

export default AboutCard;
